import './tt-web';
import '../renderer/index';

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('sw.js').catch(() => undefined);
}
